import React from "react";

import { Button, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";

import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import BackArrow from "../../Images/backarrow.png";
import plus from "../../Images/plus.png";
import usdt from "../../Images/usdt.png";
import gsx from "../../Images/gsx.png";

import { AiOutlineDown } from "react-icons/ai";
import { Link } from "react-router-dom";

import Navbar from "../Navbar/Index";
import Footer from "../Footer/Index";
import TokensDialogOne from "../../Components/Dialogs/TokensDialogOne";
import TokensDialogTwo from "../../Components/Dialogs/TokensDialogTwo";

const AddLiquiditySupply = () => {
  // for dialog
  const [opendialog, setOpendialog] = React.useState(false);
  const [useSelectedValue, setSelectedValue] = React.useState("GSX");
  const [useSelectedImg, setSelectedImg] = React.useState(gsx);

  const handleClickOpen = () => {
    setOpendialog(true);
  };

  const handleListItemClick = (value) => {
    setOpendialog(false);
    setSelectedImg(value.logoURI);
    setSelectedValue(value.symbol);
  };
  // for dialog

  // for dialog2
  const [opendialog2, setOpendialog2] = React.useState(false);
  const [useSelectedValue2, setSelectedValue2] = React.useState("USDT");
  const [useSelectedImg2, setSelectedImg2] = React.useState(usdt);
  const [useFirstVal, setFirstVal] = React.useState();
  const [useSecondVal, setSecondVal] = React.useState();
  const [useInputSlipage, setInputSlipage] = React.useState("2.0");

  const handleClickOpendialog2 = () => {
    setOpendialog2(true);
  };

  const handleListItemClick2 = (value2) => {
    setOpendialog2(false);
    setSelectedImg2(value2.logoURI);
    setSelectedValue2(value2.symbol);
  };

  // for dialog2
  const [showResults, setShowResults] = React.useState(false);
  const firstInput = (event) => {
    const val = event.target.value;
    setFirstVal(val);
    setShowResults(true);
  };
  const SecondInput = (event) => {
    const val = event.target.value;
    setSecondVal(val);
    setShowResults(true);
  };
  const handleSlipage = (event) => setInputSlipage(event.target.value);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  return (
    <div>
      <Container>
        <Navbar />
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Link to="/importpool">
                      <img
                        className="Ray---Connect---Modal---Addliquidity---BackArrowbutton"
                        alt=""
                        src={BackArrow}
                      />
                    </Link>
                    <div className="Ray__Connect__Exchange ">
                      Add Liquidity
                      <p className="Ray---connect---swap">
                        Add Liquidity To Receive LP Tokens
                      </p>
                    </div>

                    <div className="Ray__Connect__Icons pt-sm-3">
                      <img alt="" onClick={handleOpen} src={settings} />
                      <img
                        className="ml-2"
                        alt=""
                        onClick={handleOpenrec}
                        src={timer}
                      />
                    </div>
                  </div>
                  <TokensDialogOne
                    open={opendialog}
                    onClose={handleListItemClick}
                    disabling={useSelectedValue}
                  />
                  <div className="pt-4 px-3">
                    <div className="inputfield">
                      <input
                        onChange={firstInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useFirstVal}
                      />
                      <a className="alink" onClick={handleClickOpen}>
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg}
                        />
                        {useSelectedValue}
                        <span style={{ padding: "0px 0px 0px 8px" }}>
                          <AiOutlineDown />
                        </span>
                      </a>
                    </div>

                    <div className="Ray---Connect---Swapbutton">
                      <img alt="" src={plus} />
                    </div>

                    <TokensDialogTwo
                      opendialog2={opendialog2}
                      onClosedialog2={handleListItemClick2}
                      disablingtoken={useSelectedValue2}
                    />
                    <div className="inputfield">
                      <input
                        onChange={SecondInput}
                        className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                        type="number"
                        placeholder="0.00"
                        value={useSecondVal}
                      />
                      <a className="alink" onClick={handleClickOpendialog2}>
                        <img
                          className="Ray---Exchange---Dialoglogo"
                          src={useSelectedImg2}
                        />
                        {useSelectedValue2}
                        <span style={{ padding: "0px 0px 0px 8px" }}>
                          <AiOutlineDown />
                        </span>
                      </a>
                    </div>
                    <div style={{ fontSize: 12 }} className="mb-2 mt-4">
                      Prices And Pool Share
                    </div>
                    <div className="Ray---Connect---Modal---AddliqPPS---Boxes">
                      <div className="Ray---Connect---Modal---AddliqPPS---Box1">
                        100 <br />
                        GSX per Usdt
                      </div>
                      <div className="Ray---Connect---Modal---AddliqPPS---Box1">
                        0.1 <br />
                        Usdt per Gsx
                      </div>
                      <div className="Ray---Connect---Modal---AddliqPPS---Box1">
                        10% <br />
                        Share Of Pool
                      </div>
                    </div>
                    <Button className="Rey---Connect---Modal---AddLiquidityButton">
                      Supply
                    </Button>

                    <div style={{ fontSize: 12, textAlign: "center" }}>
                      <p>
                        By Adding Liquidity You'll Earn 0.17% Of All Trades On
                        This Pair Proportional To Your Share Of The Pool. Fees
                        Are Added To The Pool, Accrue In Real Time And Can Be
                        Claimed By Withdrawing Your Liquidity.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>
                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    onChange={handleSlipage}
                    className="Ray---Connect---Modal---Text "
                    type="number"
                    placeholder="2.00%"
                    value={useInputSlipage}
                  />
                </div>

                <p className="mt-2 pb-2">Transaction Deadline?</p>

                <p className="Ray---Connect---Modal---TextTransaction"> 20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className="Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>

              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +50 Gxs</span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +500 Gxs</span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* modal for recent ends ------------------------------------------*/}

        <Footer />
      </Container>
    </div>
  );
};
export default AddLiquiditySupply;
